import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { API_URL } from '../utils/api';

/**
 * Kartu ID siswa (satu lembar). Dipakai cetak tunggal & batch per kelas.
 */
const StudentIdCard = ({ card, compact = false }) => {
  if (!card) return null;

  const photoSrc = card.photo_url ? `${API_URL}${card.photo_url}` : null;
  const width = compact ? 200 : 220;
  const photoSize = compact ? 64 : 72;
  const qrSize = compact ? 170 : 200;

  return (
    <Paper
      className="student-id-card-sheet"
      elevation={4}
      sx={{
        width,
        minHeight: compact ? 300 : 340,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid #cbd5e1',
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
      }}
    >
      <Box sx={{ bgcolor: '#1e3a5f', color: '#fff', px: 2, py: 2, textAlign: 'center' }}>
        <Typography 
          variant="subtitle2" 
          sx={{ 
            fontWeight: 800, 
            textTransform: 'uppercase',
            lineHeight: 1.3,
            fontSize: compact ? '0.8rem' : '1rem'
          }}
        >
          {card.full_name}
        </Typography>
      </Box>

      <Box sx={{ p: 2, textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100% - 60px)' }}>
        {card.qr_data_url && (
          <Box
            component="img"
            src={card.qr_data_url}
            alt="QR Absensi"
            sx={{ width: qrSize, height: qrSize, margin: 'auto' }}
          />
        )}
      </Box>
    </Paper>
  );
};

export default StudentIdCard;
